module.exports = function (app) {
	require("./ebill/register")(app);

	app.controller("pages.ebill", ["$scope", function ($scope) {
		$scope.headings = "eBill";
		$scope.sidebar.links = $scope.sidebar.links || [];

		$scope.sidebar.links.push({
			heading: "eBill Registration",
			label: "Register",
			active: true,
			description: "Register for eBill to pay your online bills.",
			state: "ebill"
		});
	}]);

	return [
		{
			state: "ebill",
			url: "/ebill",
			postPassword: true,
			views: {
				"body@": {
					template: bootstrap.templates["page-templates/categoryCustom.html"],
					controller: "pages.ebill"
				},
				"content@ebill": {
					//template: require("./ebill/register.html"),
					templateUrl: 'ebill/register.appTemplate.html/chmhom/pages/ebill/register',
					controller: "pages.ebill.register"
				}
			}
		},
		{
			state: "ebill.register",
			url: "/register",
			views: {}
		}
	]
};